export const cardsQuantity = 3;
